import { IMyOffersProps } from './interfaces';
import React, { useState } from 'react';
import { sendGAEvent } from '../../domain/marketing/gtm-provider';
import DiscountBadge from '../../ui/discount-badge/discount-badge';
import ArrowIcon from '../../ui/svg/common/arrow';
import Gallery from '../galleries/gallery/gallery';
import { IJsonBanner } from '../../domain/banners/interfaces';
import Imgix from 'react-imgix';

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-1059
 * https://wavesaudio.atlassian.net/browse/DSWEB-1966
 */
const MyOffers = (props: IMyOffersProps) => {

    const [btnStyle] = useState({
        backgroundColor: props.stripBG,
        color: props.stripColor,
    });

    const [galleryHidden, setGalleryHidden] = useState(true);
    const [arrowRotationAngle, setArrowRotationAngle] = useState(180);

    /**
     * on button click -> toggle gallery
     */
    const toggleGallery = () => {

        if(!galleryHidden) {
            sendGAEvent('MyOffersFooter', 'ClosePanel');
        }
        else{
            sendGAEvent('MyOffersFooter', 'OpenPanel');
        }

        setArrowRotationAngle(galleryHidden ? 0 : 180);
        setGalleryHidden(value => !value);
    };

    return (
        <div className={`w-full ${ props.rootClass || '' }`} style={ props.style }>
            <button
                type="button"
                className="flex items-center justify-center text-center w-full h-12"
                style={btnStyle}
                onClick={ toggleGallery }>

                <ArrowIcon
                    width="18px"
                    color={ props.iconColor || '#ffffff' }
                    title="Arrow Down"
                    classes="mr-3"
                    rotationAngle={ arrowRotationAngle }
                />

                <span className={`mr-2 font-bold ${ props.textClass || '' }`}>{ props.text }</span>

                <DiscountBadge
                    text={ `${ props.data.length } Available` }
                    theme={ props.theme }
                    classes={ props.badgeClass || '' }
                />
            </button>

            {
                !galleryHidden &&
                (
                    <div className={`py-4 ${props.theme === "yellow" ? "bg-yellow-400" : "bg-gray-100"}`}>
                        <Gallery
                            classes="waves-box-lg mx-auto"
                            galleryStaticContentClasses = "mb-4 lg:mb-0"
                            galleryStaticContentArrowClasses = "mb-0"
                            style={{
                                width: '1040px',
                            }}
                            desktopItemsPerSlide={ props.data.length === 2 ? 2 : 3 }
                            tableItemsPerSlide={ 2 }
                            mobileItemsPerSlide={ 1.5 }
                            codeName="fmo"
                            items={ props.data }
                            loop={ false }
                            duration={ 800 }
                            renderItem={ (item: IJsonBanner, slideItemWidth: number) => {

                                return (
                                    <a
                                        className="block no-underline"
                                        href={ item.bannerURL }
                                        title={ item.bannerTitle }
                                        onClick={(evt) => {
                                            sendGAEvent('MyOffersFooter', item.gaValue);
                                        }}>

                                        <Imgix
                                            src={ item.bannerImage }
                                            width={ slideItemWidth }
                                            className="max-w-full"
                                            htmlAttributes={{
                                                alt: item.bannerTitle,
                                                title: item.bannerTitle,
                                                loading: 'lazy',
                                            }}
                                        />
                                    </a>
                                )
                            }}
                        />
                    </div>
                )
            }
        </div>
    )
};

export default MyOffers;
